
import { COOKIE_DURATION, cookieOpts } from '@/utils/cookieOptions'

export default {
  props: {
    countriesList: Array,
  },
  data() {
    return {
      countryId: null,
    }
  },

  mounted() {
    const countryIso = this.$nuxtCookies.get('user_country')
      ? this.$nuxtCookies.get('user_country')
      : this.$store.state.country
    const userCountryIso = this.$auth.loggedIn
      ? this.$store.$auth.user?.country?.iso
      : null
    const targetIso = userCountryIso || countryIso
    const matched = this.countriesList.find(item => item.iso === targetIso)
    if (matched) {
      this.countryId = matched.id
    }
  },
  methods: {
    setCountry() {
      const matched = this.countriesList.find(
        item => item.id === this.countryId
      )
      if (!matched) return
      this.$store.commit('SET_COUNTRY', matched.iso)
      this.$store.commit('SET_CHOSEN_COUNTRY', matched.iso)
      this.setCookieCountry()
      this.$emit('country-changed', this.countryId)
    },

    setCookieCountry() {
      this.$nuxtCookies.set('user_country', this.$store.state.country, cookieOpts(COOKIE_DURATION.YEAR))
    },
  },
}
